import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'countdownTimer' })
export class CountdownTimerPipe implements PipeTransform {
  transform(timeRemaining: number): string {
    if (!timeRemaining) {
      return '';
    }

    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    let minutesStr = minutes.toString();
    let secondsStr = seconds.toString();

    if (minutes < 10) {
      minutesStr = `0${minutesStr}`;
    }
    if (seconds < 10) {
      secondsStr = `0${secondsStr}`;
    }

    return `${minutesStr}:${secondsStr}`;
  }
}
